const now = new Date().getFullYear();
const threshold = 1950;
const timespan = now - threshold;

export const productionYears = Array.from({ length: timespan + 1 }, (_, i) => ({
  id: `${i} - ${timespan} - ${threshold}`,
  label: `${now - i}`,
  value: `${now - i}`,
}));
